import { render, staticRenderFns } from "./Moduls.vue?vue&type=template&id=fd88c6cc"
import script from "./Moduls.vue?vue&type=script&lang=js"
export * from "./Moduls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports